import popup from '../modules/Popup';
import cartUpdate from "../util/updateCart";
const { __ } = wp.i18n;

export default class AjaxAddToCart {
  constructor() {
    if ( typeof wc_add_to_cart_params === 'undefined' ) {
      return false;
    }
    if(AjaxAddToCart.exists) {
      return AjaxAddToCart.instance;
    }
    AjaxAddToCart.instance = this;
    AjaxAddToCart.exists = true;

    this.form = null;
    this.doiongRequest = false;

    this.addHandlers();
  }

  addHandlers()
  {
    document.body.addEventListener('submit', event => {
      if(event.target.classList.contains('add-to-cart-wrapper')) {
        event.preventDefault();
        this.form = event.target;
        this.onFormSubmit();
      }
    });
  }

  async onFormSubmit()
  {
    if(!this.form || this.doiongRequest) {
      return;
    }

    const submitBtn = this.form.querySelector('button[type=submit]');

    submitBtn.classList.add('loading');
    submitBtn.setAttribute('disabled', 'disabled');
    this.doiongRequest = true;

    try {
      let response = await this.request(new FormData(this.form));
      if ( ! response ) {
        return;
      }

      if ( response.error ) {
        if(response.product_url) {
          window.location = response.product_url;
        } else {
         throw new Error();
        }

        return;
      }

      // Trigger event so themes can refresh other areas.
      $( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, $(submitBtn) ] );

      //Update cart
      if(palram.is_cart) {
        cartUpdate();
      }

    } catch (e) {
      popup.open({
        title: __('Oh no...', 'canopia'),
        type: 'warning',
        message: `<p>${__('Something went wrong...')}</p>`,
        close: {
          text: __('Try again', 'canopia'),
        },
      });
    } finally {
      submitBtn.classList.remove('loading');
      submitBtn.removeAttribute('disabled');
      this.doiongRequest = false;
    }
  }

  async request(data)
  {
    return $.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'add_to_cart' ),
      processData: false,
      contentType: false,
      data,
    });
  }
}
